import { ITutorial, Tutorial } from '../../types/tutorial/index';
import { IPage, Page } from '../../types/tutorial/page';

interface IAction {
  commit: Function;
  dipsatch: Function;
  getters: any;
  rootGetters: string[];
  rootState: any;
  state: Tutorial;
}

interface IListReponse<T> {
  page: number;
  count: number;
  totalCount: number;
  list: T[];
}

export default {
  namespaced: true,
  modules: {},
  state: new Tutorial(),
  mutations: {
    import(state: Tutorial, TutorialPayload: ITutorial) {
      state.tutorialId = TutorialPayload.tutorialId;
      state.index = TutorialPayload.index;
      state.slug = TutorialPayload.slug;
      state.title = TutorialPayload.title;
      state.description = TutorialPayload.description;
      state.difficulty = TutorialPayload.difficulty;
      state.pageCount = TutorialPayload.pageCount;
      state.imageUrl = TutorialPayload.imageUrl;
      state.published = TutorialPayload.published;
    },
    addPage(state: Tutorial, PagePayload: IPage) {
      const page = new Page(PagePayload);
      state.pages.push(page);
    }
  },
  getters: {
    getPageByPageNumber(state: Tutorial) {
      return (pageNumber: number) => {
        return state.pages.find((page) => page.pageNumber === pageNumber);
      };
    },
    totalPageCount(state: Tutorial) {
      return state.pageCount;
    }
  },
  actions: {
    fetchTutorialBySlug(action: IAction, slug: string) {
      const { commit, rootGetters } = action;

      // ### update-after-backend
      return rootGetters['CodementumUser/apiRequest']({
        method: 'get',
        path: '/tutorials',
        body: {
          params: { search: 'slug==' + slug }
        },
        opt: {
          baseURL: rootGetters['workspace/mainApi']
        },
        onSuccess(data: IListReponse<ITutorial>) {
          commit('import', data.list[0]);
        }
      });
    },
    fetchPageByPageNumber(action: IAction, pageNumber: number) {
      const { state, commit, rootGetters } = action;

      // ### update-after-backend
      return rootGetters['CodementumUser/apiRequest']({
        method: 'get',
        path: '/tutorials/' + state.tutorialId + '/pages/' + pageNumber,
        opt: {
          baseURL: rootGetters['workspace/mainApi']
        },
        onSuccess(data: IPage) {
          commit('addPage', data);
        }
      });
    }
  }
};
